import React from "react";

interface IconProps {
  size?: number;
  className?: string;
}

const SearchIcon: React.FC<IconProps> = ({ size = 18, className = "" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 18 18"
      fill="none"
      width={size}
      height={size}
      className={className}
    >
      <g filter="url(#filter0_d_673_7900)">
        <path
          d="M11.0038 12.5113C10.5731 12.739 10.2035 12.9699 9.80772 13.1378C8.05054 13.883 6.29337 13.873 4.55496 13.0699C3.26706 12.4748 2.28364 11.5339 1.5971 10.2838C0.975965 9.15318 0.720159 7.93543 0.810667 6.64186C0.890527 5.49969 1.24825 4.45419 1.86938 3.5038C2.49128 2.55264 3.30762 1.81407 4.31005 1.28991C5.3277 0.757516 6.40923 0.523839 7.55161 0.574996C8.88033 0.634636 10.0762 1.07423 11.1367 1.88503C12.3343 2.80045 13.138 3.99532 13.5117 5.46704C13.9523 7.20278 13.7219 8.85883 12.8409 10.4146C12.7587 10.5596 12.762 10.6357 12.8819 10.7565C14.0403 11.92 15.1903 13.092 16.3443 14.2596C16.7434 14.6635 16.8965 15.1321 16.7211 15.6884C16.4576 16.5239 15.3812 16.847 14.7119 16.2925C14.6275 16.2226 14.5461 16.1478 14.469 16.0694C13.3411 14.9272 12.2139 13.7846 11.0883 12.6403C11.0449 12.5961 11.0188 12.5347 11.0041 12.5115L11.0038 12.5113ZM2.88703 7.11744C2.8817 9.55652 4.84626 11.5491 7.25803 11.5504C9.666 11.5516 11.6394 9.55112 11.6303 7.11795C11.6212 4.67527 9.68298 2.71022 7.2664 2.693C4.87009 2.67603 2.8926 4.67398 2.88703 7.11744Z"
          fill="#F1F9FE"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_673_7900"
          x="0.499239"
          y="0.568115"
          width="16.5875"
          height="17.0281"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.734324" />
          <feGaussianBlur stdDeviation="0.146865" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_673_7900"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_673_7900"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default SearchIcon;
